import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import FamilyTree from "./FamilyTree/FamilyTree";
import RegisterMember from "./RegisterMember"; //

const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  "https://familyduniya-dev.censeotech.com/api-family";

const token = null;

const FamilyTreeDisplay = () => {
  const { id } = useParams();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showRegister, setShowRegister] = useState(false);

  // 🔥 FACTORED OUT SO WE CAN CALL IT AFTER DELETE OR ADD
  const fetchFamilyGraph = async () => {
    if (!id) return;

    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(`${API_BASE}/family/${id}/graph`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      setMembers(res.data.members || []);
    } catch (err) {
      console.error("Error fetching family graph:", err);
      setError("Failed to load family tree.");
      setMembers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id) {
      setLoading(false);
      setError("No family ID provided.");
      return;
    }

    fetchFamilyGraph();
  }, [id]);

  const renderContent = () => {
    return (
      <div className="w-screen h-screen overflow-auto bg-white">
        {loading ? (
          <div className="p-4 text-center">Loading family tree...</div>
        ) : error ? (
          <div className="p-4 text-center text-red-600">{error}</div>
        ) :members.length === 0 ? (
  <div className="p-4 text-center">
    <p>No members found for this family.</p>

    <button
      className="mt-4 px-4 py-2 bg-green-600 text-white rounded"
      onClick={() => setShowRegister(true)}
    >
      Add First Member
    </button>

    {/* 🔥 ROOT MEMBER MODAL */}
   {showRegister && (
  <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded shadow-lg w-196  text-left">
      <RegisterMember
        selectedPerson={null}
        editMode={false}
        closeModal={() => setShowRegister(false)}
        onUpdateMembers={() => {
          setShowRegister(false);
          fetchFamilyGraph();
        }}
      />
    </div>
  </div>
)}

  </div>
)
 : (
          <div className="w-full h-full overflow-auto bg-white">
            <div className="min-w-[900px]">
              <FamilyTree 
                data={members[0]} 
                id={id} 
                onUpdateMembers={fetchFamilyGraph}  // 🔥 IMPORTANT FIX
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen flex justify-center items-start bg-white">
      {renderContent()}
    </div>
  );
};

export default FamilyTreeDisplay;
